import { getCurrentSession } from "@/libs/auth/utils";
import { createMiddleware } from "@tanstack/react-start";

export const authMiddleware = createMiddleware().server(async ({ next }) => {
  const auth = await getCurrentSession();

  return next({
    context: {
      auth,
    },
  });
});
